const flights = {
  flight: "Paglipad", // translated 
  flights: "Mga Paglipad", // translated 
  originDepartureDate: "Pag-alis", // translated 
  destinationDepartureDate: "Pagbabalik", // translated 
  outbound: "Palabas", // translated 
  inbound: "Papasok", // translated 
  travelTime: "Oras ng paglalakbay", // translated 
  selected: "napili", // translated 
  select: "pumili", // translated 
  airline: "Airline", // translated 
  directFlight: "Direktang paglipad", // translated 
  baggage: "Bagahe", // translated 
  stops: "Mga Hinto", // translated 
  nonStop: "Walang tigil", // translated 
  oneStopMax: "Pinakamataas na one-stop", // translated 
  twoStopsMax: "Pinakamataas na dalawang hinto", // translated 
  anyStops: "Sa anumang paghinto", // translated 
  smallBaggage: "Maliit na bagahe", // translated 
  bigBaggage: "Malaking bagahe", // translated 
  smallAndBigBaggage: "Maliit at malaking bagahe", // translated 
  outboundStops: "Mga hintuan palabas", // translated 
  inboundStops: "Mga hintuan na papasok", // translated 
  selectAirline: "Pumili ng Airline", // translated 
  baggageOption: "Opsyon sa bagahe", // translated 
  outboundDepartureAfter: "Paalis na pag-alis pagkatapos", // translated 
  outboundArrivalAfter: "Pagdating palabas pagkatapos", // translated 
  inboundDepartureAfter: "Papasok na pag-alis pagkatapos", // translated 
  inboundArrivalTimeAfter: "Pagdating papasok pagkatapos", // translated 
  flightClass: "Klase ng paglipad", // translated 
  outboundDepAfter: "Pag-alis pagkatapos", // translated 
  outboundArrivalAfrer: "Pagdating pagkatapos", // translated 
  inboundDepAfter: "Sa pag-alis pagkatapos", // translated 
  inboundArrivalAfter: "Pagdating pagkatapos", // translated 
  airlines: "Mga Airline", // translated 
  lessThan: "Mas mababa sa", // translated 
  layover: "Pagtigil", // translated 
  duration: "Tagal", // translated 
  noClassPreference: "Walang Kagustuhan sa Klase", // translated 
  economy: "Ekonomiya", // translated 
  business: "Negosyo", // translated 
  with: "Gamit", // translated 
  without: "Kung wala", // translated 
  twoOrMore: "Dalawa o higit pa", // translated 
  departure: "Pag-alis", // translated 
  return: "Pagbabalik", // translated 
  submit: "Isumite", // translated 
  priceLessThan: "Mas mababa ang presyo kaysa sa", // translated 
  durationLessThan: "Tagal na mas mababa sa", // translated 
  layoverLessThan: "Mas mababa sa pahinga", // translated 
  noLayover: "Walang pagtigil", // translated 
  durationLowestFirst: "Tagal (pinakamababa muna)", // translated 
  durationHighestFirst: "Tagal (pinakamataas muna)", // translated 
  idType: "Uri ng ID", // translated 
  idPassportCode: "Kodigo ng ID/Pasaporte", // translated 
  expirationDate: "Petsa ng Pagtatapos", // translated 
  frequentFlyerNumber: "Numero ng Madalas na Lumilipad", // translated 
  frequentFlyerAirline: "Airline na Madalas Lumipad", // translated 
  dateOfBirth: "Petsa ng Kapanganakan", // translated 
  infant: "Sanggol", // translated 
  phone: "Telepono", // translated 
  title: "Pamagat", // translated 
  noLuggageIncluded: "Walang Kasamang Bagahe", // translated 
  includesLuggage: "Kasama ang mga bagahe", // translated 
  outboundFlight: "Palabas na Paglipad", // translated 
  inboundFlight: "Papasok na Paglipad", // translated 
  flightNumber: "Numero ng Paglipad", // translated 
  flightNumbers: "Mga Numero ng Paglipad", // translated 
  cabinClassType: "Uri ng Klase ng Cabin", // translated 
  class: "Klase", // translated 
  aircraft: "Sasakyang panghimpapawid", // translated 
  aircraftType: "Uri ng Sasakyang Panghimpapawid", // translated 
  airlineName: "Pangalan ng Airline", // translated 
  no: "Hindi", // translated 
  yes: "Oo", // translated 
  anyFlights: "Anumang mga Flight", // translated 
  oneStop: "Isang Hinto", // translated 
  direct: "Direkta", // translated 
  directFlights: "Mga Direktang Paglipad", // translated 
  all: "Lahat", // translated 
  first: "Una", // translated 
  premiumEconomy: "Prem. Economy", // translated 
  withBaggageOnly: "May Bagahe Lamang", // translated 
  oneWay: "Isang Daan", // translated 
  roundTrip: "Paglalakbay Pabalik-balik", // translated 
  withBaggage: "May Bagahe", // translated 
  noBaggagePreference: "Walang Mas Gustong Bagahe", // translated 
  noBaggage: "Bawal ang Bagahe", // translated 
  requiredFields: "Mga Kinakailangang Patlang", // translated 
  nonRequiredFields: "Mga Hindi Kinakailangang Patlang", // translated 
  cabinClass: "Klase ng Kabin", // translated 
  brandName: "Pangalan ng Tatak", // translated 
  performNewSearch: "Magsagawa ng bagong paghahanap", // translated 
  outboundDeparture: "Paalis na Pag-alis", // translated 
  inboundDeparture: "Papasok na Pag-alis", // translated 
  created: "Nilikha", // translated 
  freeCancellationAvailable: "Libreng Pagkansela", // translated 
  freeCancellationDeadline: "Libreng Huling Araw ng Pagkansela", // translated 
  externalReference: "Panlabas na Sanggunian", // translated 
  outboundflightNumber: "Numero ng Palabas na Paglipad", // translated 
  inboundflightNumber: "Numero ng Papasok na Paglipad", // translated 
  arrival: "Pagdating", // translated 
  originAirport: "Pinagmulang Paliparan", // translated 
};


export default flights;
